import type { EventMetadata } from './BaseEvent.js';

/**
 * Web Vitals metric names
 */
export type WebVitalName = 'CLS' | 'INP' | 'FCP' | 'LCP' | 'TTFB';

/**
 * Web Vitals rating
 */
export type WebVitalRating = 'good' | 'needs-improvement' | 'poor';

/**
 * Web Vital event optimized for ClickHouse time-series analysis
 */
export interface WebVitalEvent extends EventMetadata {
  event_category: 'performance';
  event_type: 'web_vital';

  // Metric details (flat structure)
  metric_name: WebVitalName;      // LowCardinality
  metric_value: number;           // Float64
  metric_rating: WebVitalRating;  // LowCardinality
  metric_delta: number;           // Float64
  metric_id: string;              // Unique metric ID for deduplication
}

/**
 * Create web vital event from web-vitals library metric
 */
export function createWebVitalEvent(
  baseMetadata: EventMetadata,
  metric: {
    name: WebVitalName;
    value: number;
    rating: WebVitalRating;
    delta: number;
    id: string;
  }
): WebVitalEvent {
  return {
    ...baseMetadata,
    event_category: 'performance',
    event_type: 'web_vital',
    metric_name: metric.name,
    metric_value: metric.value,
    metric_rating: metric.rating,
    metric_delta: metric.delta,
    metric_id: metric.id
  };
}

